import axios from "axios";

// 開発時は proxy (package.json) 経由で同じバックエンドに届けるため空にする
const baseURL =
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== "undefined" && window.location.port === "3000" ? "" : "http://localhost:8000");

const client = axios.create({
  baseURL,
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("access"); // JWT使ってるなら
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;
